export const update_feature_count = function (state) {
    if (state.draw && state.active_projects && Object.values(state.active_projects).length) {
        let filtered_features = [];
        for (let layer of Object.values(state.active_projects)) {
            if (layer.is_feature_active && layer.filtered_features)
                filtered_features.push(...layer.filtered_features)
        }
        const all_features = [...state.draw.getAll().features, ...filtered_features]
        const feature_count = _.countBy(all_features, feature => feature.properties.featureTypeId)
        for (let v of Object.values(state.features_count)) {
            state.features_count[v.class_id].count = feature_count[v.class_id] || 0;
        }
        state.features_count = Object.assign({}, state.features_count);
    }
    state.active_projects = {...state.active_projects}

}
export const init_feature_colors = function (state) {
    try {
        let stops = [];
        if (state.feature_type_groups && state.feature_type_groups.length) {
            for (let fg of state.feature_type_groups) {
                for (let f of fg.featureTypes)
                    if (f.properties.color != "none") {
                        stops.push([f.id, f.properties.color || '#222']);
                    }
            }
            stops = stops.sort((a, b) => (a[0] - b[0]));
        } else {
            stops = [[1, "black"]];
        }
        // POLYGON FILL STYLES
        state.map.setPaintProperty(
            "gl-draw-polygon-fill-active.cold",
            "fill-color",
            {
                property: "user_featureTypeId",
                stops: stops,
                default: "black"
            }
        );
        // POLYGON LINE STYLES
        state.map.setPaintProperty("gl-draw-polygon-stroke-inactive.cold", "line-color", {
            property: "user_featureTypeId",
            stops: stops,
            default: "black"
        });

        state.map.setPaintProperty("gl-draw-polygon-stroke-inactive.hot", "line-color", {
            property: "user_featureTypeId",
            stops: stops,
            default: "black"
        });

        state.map.setPaintProperty("gl-draw-polygon-stroke-active.cold", "line-color", {
            property: "user_featureTypeId",
            stops: stops,
            default: "black"
        });

        state.map.setPaintProperty("gl-draw-polygon-stroke-active.hot", "line-color", {
            property: "user_featureTypeId",
            stops: stops,
            default: "black"
        });

        // LINE STYLES
        state.map.setPaintProperty("gl-draw-line-inactive.cold", "line-color", {
            property: "user_featureTypeId",
            stops: stops,
            default: "black"
        });

        state.map.setPaintProperty("gl-draw-line-inactive.hot", "line-color", {
            property: "user_featureTypeId",
            stops: stops,
            default: "black"
        });

        state.map.setPaintProperty("gl-draw-line-active.cold", "line-color", {
            property: "user_featureTypeId",
            stops: stops,
            default: "black"
        });

        state.map.setPaintProperty("gl-draw-line-active.hot", "line-color", {
            property: "user_featureTypeId",
            stops: stops,
            default: "black"
        });

        // points colors
        state.map.setPaintProperty("gl-draw-point-active.cold", "circle-color", {
            property: "user_featureTypeId",
            stops: stops,
            default: "yellow"
        });
        state.map.setPaintProperty("gl-draw-point-active.hot", "circle-color", {
            property: "user_featureTypeId",
            stops: stops,
            default: "yellow"

        });
        state.map.setPaintProperty("gl-draw-point-inactive.cold", "circle-color", {
            property: "user_featureTypeId",
            stops: stops,
            default: "yellow"
        })
        state.map.setPaintProperty("gl-draw-point-inactive.hot", "circle-color", {
            property: "user_featureTypeId",
            stops: stops,
            default: "yellow"
        });


        state.map.setPaintProperty(
            "gl-draw-polygon-fill-inactive.cold",
            "fill-opacity",
            0
        );
        state.map.setPaintProperty(
            "gl-draw-polygon-fill-inactive.hot",
            "fill-opacity",
            0
        );
        state.map.setPaintProperty(
            "gl-draw-polygon-fill-active.cold",
            "fill-opacity",
            0.25
        );

        state.map.setPaintProperty(
            "gl-draw-polygon-fill-active.hot",
            "fill-color",
            {
                property: "user_featureTypeId",
                stops: stops
            }
        );

        state.map.setPaintProperty(
            "gl-draw-polygon-fill-active.hot",
            "fill-opacity",
            0.25
        );

        // point radius
        state.map.setPaintProperty("gl-draw-point-active.cold", "circle-radius", {
            property: "user_elevation",
            stops:
                [
                    [0, 5],
                    [1, 10]
                ]

        });
        state.map.setPaintProperty("gl-draw-point-active.hot", "circle-radius", {
            property: "user_elevation",
            stops:
                [
                    [0, 5],
                    [1, 10]
                ]

        });
        state.map.setPaintProperty("gl-draw-point-inactive.cold", "circle-radius", {
            property: "user_elevation",
            stops: [
                [0, 5],
                [1, 10]
            ]
        });
        state.map.setPaintProperty("gl-draw-point-inactive.hot", "circle-radius", {
            property: "user_elevation",
            stops: [
                [0, 5],
                [1, 10]
            ]
        });
        // color point
        // state.map.setPaintProperty("gl-draw-point-inactive.cold", "circle-color", {
        //     property: "user_elevation",
        //     stops: [
        //         [0, "#e0d802"],
        //         [1, "#e0d802"]
        //     ]
        // });
        // state.map.setPaintProperty("gl-draw-point-inactive.hot", "circle-color", {
        //     property: "user_elevation",
        //     stops: [
        //         [0, "#e0d802"],
        //         [1, "#e0d802"]
        //     ]
        // });
        // state.map.setPaintProperty("gl-draw-point-active.cold", "circle-color", {
        //     property: "user_elevation",
        //     stops: [
        //         [0, "#e0d802"],
        //         [1, "#e0d802"]
        //     ]
        // });
        // state.map.setPaintProperty("gl-draw-point-active.hot", "circle-color", {
        //     property: "user_elevation",
        //     stops: [
        //         [0, "#e0d802"],
        //         [1, "#e0d802"]
        //     ]
        // });
        // for edit_mode features

        // FOR BOUNDS
        state.map.setPaintProperty(
            "gl-draw-polygon-fill-active.hot",
            "fill-color",
            {
                property: "user_bounds",
                stops: [[1, "yellow"]]
            }
        );
        state.map.setPaintProperty(
            "gl-draw-polygon-fill-active.cold",
            "fill-color",
            {
                property: "user_bounds",
                stops: [[1, "yellow"]]
            }
        );
        state.map.setPaintProperty(
            "gl-draw-polygon-fill-inactive",
            "fill-color",
            {
                property: "user_bounds",
                stops: [[1, "yellow"]]
            }
        );
        state.map.setPaintProperty(
            "gl-draw-polygon-stroke-active.cold",
            "line-width",
            {
                property: "user_edit_mode",
                stops: [[1, 4]],
                default: 2
            }
        );
        state.map.setPaintProperty(
            "gl-draw-polygon-stroke-active.hot",
            "line-width",
            {
                property: "user_edit_mode",
                stops: [[1, 4]],
                default: 2
            }
        );
        state.map.setPaintProperty(
            "gl-draw-polygon-stroke-inactive.cold",
            "line-width",
            {
                property: "user_edit_mode",
                stops: [[1, 4]],
                default: 2
            }
        );
        state.map.setPaintProperty(
            "gl-draw-polygon-stroke-inactive.hot",
            "line-width",
            {
                property: "user_edit_mode",
                stops: [[1, 4]],
                default: 2
            }
        );
    } catch (err) {
        console.log("Loading styles")
    }
}